"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataListCell = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utilities_1 = require("../../utilities");
var DataListCell = function (_a) {
    var _b;
    var className = _a.className, align = _a.align, width = _a.width, wrapping = _a.wrapping, props = __rest(_a, ["className", "align", "width", "wrapping"]);
    var classes = classnames_1.default('DataList__Cell', className, (_b = {},
        _b["ta-" + align] = align,
        _b['DataList__Cell--wrapped'] = wrapping,
        _b));
    return (react_1.default.createElement("div", __assign({ className: classes, style: { width: width } }, props), utilities_1.getContent(props)));
};
exports.DataListCell = DataListCell;
//# sourceMappingURL=DataListCell.js.map